let nestedModalOpenCount = 0

export function registerDashboardNestedModal() {
  nestedModalOpenCount += 1
  document.body.classList.add('dashboard-nested-modal-open')
}

export function unregisterDashboardNestedModal() {
  nestedModalOpenCount = Math.max(0, nestedModalOpenCount - 1)
  if (nestedModalOpenCount === 0) {
    document.body.classList.remove('dashboard-nested-modal-open')
  }
  document.body.classList.add('dashboard-nested-modal-closing')
  setTimeout(() => {
    document.body.classList.remove('dashboard-nested-modal-closing')
  }, 0)
}

export function isDashboardNestedModalActive() {
  return (
    nestedModalOpenCount > 0 ||
    document.body.classList.contains('dashboard-nested-modal-open') ||
    document.body.classList.contains('dashboard-nested-modal-closing')
  )
}

export function isClickInsideDashboardOverlay(target) {
  if (!target || !target.closest) {
    return false
  }

  return !!(
    target.closest('.el-dialog__wrapper') ||
    target.closest('.el-message-box__wrapper') ||
    target.closest('.v-modal') ||
    target.closest('.el-dialog')
  )
}

export function shouldIgnoreDashboardPopoverDismiss(e) {
  return isClickInsideDashboardOverlay(e.target) || isDashboardNestedModalActive()
}

export function shouldDismissDashboardPopover(e, popper, popperClickTarget) {
  const popperContent = popper && popper.$refs && popper.$refs.popper
  const clickedInsidePopper = popperContent && popperContent.contains(e.target)

  return (
    e.target !== popper.$el &&
    e.target !== popperClickTarget &&
    !clickedInsidePopper &&
    !shouldIgnoreDashboardPopoverDismiss(e)
  )
}

export function patchPopoverDocumentClick(popoverComponent) {
  if (!popoverComponent || popoverComponent.__dashboardPopoverClickPatched) {
    return
  }

  const originalHandleDocumentClick = popoverComponent.handleDocumentClick.bind(popoverComponent)
  popoverComponent.handleDocumentClick = e => {
    if (shouldIgnoreDashboardPopoverDismiss(e)) {
      return
    }
    originalHandleDocumentClick(e)
  }
  popoverComponent.__dashboardPopoverClickPatched = true
}
